import { render, staticRenderFns } from "./tripTypeSelect.vue?vue&type=template&id=58aa0cc2&"
import script from "./tripTypeSelect.vue?vue&type=script&lang=js&"
export * from "./tripTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./tripTypeSelect.vue?vue&type=style&index=0&id=58aa0cc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports